import React, { PropsWithChildren } from 'react';
import { connect } from 'react-redux';
import { selectPhotoById } from '@ff-scene-plugins/photo-prints-redux/slices/photosSlice';
import { PhotoPrintsPdpState } from '@ff-scene-plugins/photo-prints-redux/store';
import { PhotoPrintsJson } from '@ff-scene-plugins/photo-prints-shared/PhotoPrintsJson';
import { PhotoPrintSpinner } from './PhotoPrintSpinner';

const _PhotoPrintLoader = ({ photo, children }: Props) => {

    if (!photo.processed) {
        return (
            <PhotoPrintSpinner />
        );
    }

    return (<>{children}</>);
};

type Props = OwnProps & {
    photo: PhotoPrintsJson.Photo;
};

type OwnProps = PropsWithChildren<{ id: string }>;

const mapStateToProps = (state: PhotoPrintsPdpState, ownProps: OwnProps) => ({
    photo: selectPhotoById(state, ownProps.id)!
});

export const PhotoPrintLoader = connect(mapStateToProps)(_PhotoPrintLoader);